// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"bb416ec6","223":"279b37e5","541":"0c0b2055","787":"9575797d"}[chunkId] + ".chunk.js";
};